import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Screens from "@/pages/Screens";
import Templates from "@/pages/Templates";
import Designs from "@/pages/Designs";
import MenuEditor from "@/pages/MenuEditor";
import TVDisplay from "@/pages/TVDisplay";
import DesignPreview from "@/pages/DesignPreview";
import Groups from "@/pages/Groups";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import Banners from "@/pages/Banners";
import Setup from "@/pages/Setup";
import Admin from "@/pages/Admin";
import AdminFleet from "@/pages/AdminFleet";
import Assets from "@/pages/Assets";
import Playlists from "@/pages/Playlists";
import Apps from "@/pages/Apps";
import BrandKit from "@/pages/BrandKit";
import Locations from "@/pages/Locations";
import Download from "@/pages/Download";
import SmartSlotsDemo from "@/pages/SmartSlotsDemo";
import Support from "@/pages/Support";
import Credits from "@/pages/Credits";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/download" element={<Download />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/tv" element={<TVDisplay />} />
            <Route path="/preview/:id" element={<DesignPreview />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard/screens" element={<ProtectedRoute><Screens /></ProtectedRoute>} />
            <Route path="/dashboard/setup" element={<ProtectedRoute><Setup /></ProtectedRoute>} />
            <Route path="/dashboard/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
            <Route path="/dashboard/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
            <Route path="/dashboard/smart-slots-demo" element={<ProtectedRoute><SmartSlotsDemo /></ProtectedRoute>} />
            <Route path="/dashboard/designs" element={<ProtectedRoute><Designs /></ProtectedRoute>} />
            <Route path="/dashboard/designs/:id" element={<ProtectedRoute><MenuEditor /></ProtectedRoute>} />
            <Route path="/dashboard/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/dashboard/credits" element={<ProtectedRoute><Credits /></ProtectedRoute>} />
            <Route path="/dashboard/banners" element={<ProtectedRoute><Banners /></ProtectedRoute>} />
            <Route path="/dashboard/assets" element={<ProtectedRoute><Assets /></ProtectedRoute>} />
            <Route path="/dashboard/playlists" element={<ProtectedRoute><Playlists /></ProtectedRoute>} />
            <Route path="/dashboard/apps" element={<ProtectedRoute><Apps /></ProtectedRoute>} />
            <Route path="/dashboard/brand-kit" element={<ProtectedRoute><BrandKit /></ProtectedRoute>} />
            <Route path="/dashboard/locations" element={<ProtectedRoute><Locations /></ProtectedRoute>} />
            <Route path="/dashboard/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/dashboard/admin/fleet" element={<ProtectedRoute><AdminFleet /></ProtectedRoute>} />
            <Route path="/dashboard/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
            <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
